import React, { Fragment } from 'react';
// import { history } from './../routers/Router';
import FooterPrivate from './FooterPrivate';
import FooterPublic from './FooterPublic';
import Dashboard from './Dashboard';
import PageNotFound from './PageNotFound';
import './../css/Pages.css';
import LoginForm from '../components/LoginForm';
import SetNewPasswordForm from '../components/SetNewPasswordForm';
import SidebarLeft from '../components/SidebarLeft';
import HeaderPrivate from '../components/HeaderPrivate';
import Banner from '../components/Banner';
import SystemIntegrator from '../components/SystemIntegrator';
import ProjectDetails from '../components/ProjectDetails';
import D2H from '../components/D2H';
import AiDashboard from '../components/AiDashboard';
import AddChannel from '../components/AddChannel';
import EditChannel from '../components/EditChannel';
import DeleteChannel from '../components/DeleteChannel';
import AddNewChannel from '../components/AddNewChannel';
import Music from '../components/Music';
import MusicPushData from '../components/MusicPushData';
import Misc from '../components/Misc';
import Movies from '../components/Movies';
import MoviesPushData from '../components/MoviesPushData';
import PushData from '../components/PushData';
import D2HShowsAi from '../components/D2HShowsAi';
import D2HShowsAiPushData from '../components/D2HShowsAiPushData';
import AllDevices from '../components/AllDevices';
import OkasBoxes from '../components/OkasBoxes';
import MemberLicense from '../components/MemberLicense';
import WarrantyOkasBox from '../components/WarrantyOkasBox';
import AssignOkasboxes from '../components/AssignOkasboxes';
import AssignMemberLicense from '../components/AssignMemberLicense';
import EditChannelNew from '../components/EditChannelNew';
import Support from '../components/Support';
import TicketSupport from '../components/TicketSupport';
import banner1 from '../assets/images/banner.jpg';
import InternalVersion from '../components/InternalVersion';
import PublicVersion from '../components/PublicVersion';
import D2HList from '../components/D2HList';
import Distributor from '../components/Distributor';
import Knowledge from '../components/Knowledge';
import Video from '../components/Video';
import UpcomingEvents from '../components/UpcomingEvents';
import WhatsNew from '../components/WhatsNew';
import Subscriptions from '../components/Subscriptions';
import MarketSpace from '../components/marketSpace';
import MarketSpaceForm from '../components/marketSpaceForm';
import MarketSpaceFormEdit from '../components/marketSpaceFormEdit';
import MarketSpaceDownload from '../components/marketSpaceDownload';
import SubscriptionPlan from '../components/SubscriptionPlan';
import OkasAdditionalInventoryRequest from '../components/OkasAdditionalInventoryRequest';
import SupportRemoteRequest from '../components/SupportRemoteAccess';
import DesignStudioRemoteAccess from '../components/DesignStudioRemoteAccess';
import Role from '../components/Role';
import User from '../components/User';
import Ota from '../components/ota';
import OtaBeta from '../components/OtaBeta';
import OtaCrashLogsList from '../components/OtaCrashLogsList';


// this will generate the pages as a whole which is served in Router.js file. This fill structure the app according to the page we create.
const PagePrivate = ({ children }) => {
  if (localStorage.getItem('token') === null) {
    window.location.href = '/'
    return null;
  } else {
    return (
      <Fragment>
        <div className="container-fluid" style={{ margin: '0px', padding: '0px' }}
        >
          <div className="row" style={{ margin: '0px', padding: '0px' }}>
            <HeaderPrivate />
          </div>
          <div className="row" style={{ margin: '0px', padding: '0px' }} >
            <SidebarLeft />
            <div className="float-left-dashboard" >
              {children}
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const PagePrivateDashboard = ({ children }) => {
  if (localStorage.getItem('token') === null) {
    window.location.href = '/'
    return null;
  } else {
    return (
      <Fragment>
        <div className="" >
          <div className="row" style={{ margin: '0px', padding: '0px', }} >
            <HeaderPrivate />
          </div>
          <div className="col-12 dahboard-custom-page" style={{ marginTop: '100px' }}>
            {children}
          </div>
        </div>
      </Fragment>
    );
  }
}


export const PagePublic = () =>
  <Fragment>
    <div className="container-fluid row p-0 m-0 backgroundImage" style={{ backgroundImage: `url(${banner1})`, backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%' }}  >
      <div className="col-6">
        <Banner />
      </div>
      <div className="col-6 ">
        <div className="row vertical-center-login-form">
          <LoginForm />
        </div>
      </div>
    </div>
  </Fragment>


export const PageSetNewPassword = () =>
  <Fragment>
    <div className="container-fluid row p-0 m-0 backgroundImage" style={{ backgroundImage: `url(${banner1})` , backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%' }}  >
      <div className="col-6">
        <Banner />
      </div>
      <div className="col-6 ">
        <div className="row vertical-center-login-form">
          <SetNewPasswordForm />
        </div>
      </div>
    </div>
  </Fragment>



export const PageDashboard = () =>
  <PagePrivateDashboard >
    <Dashboard />
  </PagePrivateDashboard>

export const PagePageNotFound = () =>
  <PagePrivateDashboard >
    <PageNotFound />
  </PagePrivateDashboard>

export const PageSystemIntegratorMaster = () =>
  <PagePrivate >
    <SystemIntegrator />
  </PagePrivate>

export const PageOkasBoxes = () =>
  <PagePrivate >
    <OkasBoxes />
  </PagePrivate>

export const PageMemberLicense = () =>
  <PagePrivate >
    <MemberLicense />
  </PagePrivate>

export const PageWarrantyOkasBox = () =>
  <PagePrivate >
    <WarrantyOkasBox />
  </PagePrivate>

export const PageAssignOkasboxes = () =>
  <PagePrivate >
    <AssignOkasboxes />
  </PagePrivate>

export const PageAssignMemberLicense = () =>
  <PagePrivate >
    <AssignMemberLicense />
  </PagePrivate>

export const PageSupport = () =>
  <PagePrivate >
    <Support />
  </PagePrivate>


export const PageDesignStudioRemoteAccess = () =>
  <PagePrivate >
    <DesignStudioRemoteAccess />
  </PagePrivate>


export const PageSupportRemoteAccess = () =>
  <PagePrivate >
    <SupportRemoteRequest />
  </PagePrivate>


export const PageTicketSupport = () =>
  <PagePrivate >
    <TicketSupport />
  </PagePrivate>

export const PageInternalVersion = () =>
  <PagePrivate >
    <InternalVersion />
  </PagePrivate>

export const PagePublicVersion = () =>
  <PagePrivate >
    <PublicVersion />
  </PagePrivate>

export const PageProjectDetails = () =>
  <PagePrivate >
    <ProjectDetails />
  </PagePrivate>
export const PageD2H = () =>
  <PagePrivate >
    <D2H />
  </PagePrivate>
export const PageD2HList = () =>
  <PagePrivate >
    <D2HList />
  </PagePrivate>

export const PageAiDashboard = () =>
  <PagePrivate >
    <AiDashboard />
  </PagePrivate>
export const PageAddChannel = () =>
  <PagePrivate >
    <AddChannel />
  </PagePrivate>
export const PageEditChannel = () =>
  <PagePrivate >
    {/* <EditChannel/> */}
    <EditChannelNew />
  </PagePrivate>

export const PageDeleteChannel = () =>
  <PagePrivate >
    <DeleteChannel />
  </PagePrivate>


export const PageAddNewChannel = () =>
  <PagePrivate >
    <AddNewChannel />
  </PagePrivate>

export const PageMovies = () =>
  <PagePrivate >
    <Movies />
  </PagePrivate>

export const PageMoviesPushData = () =>
  <PagePrivate >
    <MoviesPushData />
  </PagePrivate>


export const PageMisc = () =>
  <PagePrivate >
    <Misc />
  </PagePrivate>

export const PageMusic = () =>
  <PagePrivate >
    <Music />
  </PagePrivate>

export const PageMusicPushData = () =>
  <PagePrivate >
    <MusicPushData />
  </PagePrivate>


export const PageAllDevices = () =>
  <PagePrivate >
    <AllDevices />
  </PagePrivate>

export const PagePushData = () =>
  <PagePrivate >
    <PushData />
  </PagePrivate>

export const PageD2HShowsAi = () =>
  <PagePrivate >
    <D2HShowsAi />
  </PagePrivate>

export const PageD2HShowsAiPushData = () =>
  <PagePrivate >
    <D2HShowsAiPushData />
  </PagePrivate>

export const PageDistributor = () =>  // Distributor Added
  <PagePrivate >
    <Distributor />
  </PagePrivate>


export const PageKnowledge = () =>  // KUVW Added
  <PagePrivate >
    <Knowledge />
  </PagePrivate>

export const PageVideo = () =>  // Video Added
  <PagePrivate >
    <Video />
  </PagePrivate>

export const PageUpcomingEvents = () =>  // Video Added
  <PagePrivate >
    <UpcomingEvents />
  </PagePrivate>

export const PageWhatsNew = () =>  // Video Added
  <PagePrivate >
    <WhatsNew />
  </PagePrivate>

export const PageSubscriptions = () =>  // Subscriptions Added
  <PagePrivate >
    <Subscriptions />
  </PagePrivate>

export const PageMarketSpace = () =>  // Market Space Added
  <PagePrivate >
    <MarketSpace />
  </PagePrivate>

export const PageMarketSpaceForm = () =>  // Market Space Form Added
  <PagePrivate >
    <MarketSpaceForm />
  </PagePrivate>

export const PageMarketSpaceFormEdit = () =>  // Market Space Form Edit Added
  <PagePrivate >
    <MarketSpaceFormEdit />
  </PagePrivate>

export const PageMarketSpaceDownload = () =>  // Market Space Form Added
  <PagePrivate >
    <MarketSpaceDownload />
  </PagePrivate>

export const PageSubscriptionsPlan = () =>  // Subscriptions plan Added
  <PagePrivate >
    <SubscriptionPlan />
  </PagePrivate>


export const PageOkasAdditionalInventoryRequest = () =>  // Subscriptions plan Added
  <PagePrivate >
    <OkasAdditionalInventoryRequest />
  </PagePrivate>


export const PageRole = () =>  // Role plan Added
  <PagePrivate >
    <Role />
  </PagePrivate>

export const PageUser = () =>  // User plan Added
  <PagePrivate >
    <User />
  </PagePrivate>
export const PageOta = () =>  // OTA plan Added
  <PagePrivate >
    <Ota />
  </PagePrivate>
export const PageOtaBeta = () =>  // OTA plan Added
  <PagePrivate >
    <OtaBeta />
  </PagePrivate> 
  export const PageOtaCrashLogsList = () =>  // OTA plan Added
  <PagePrivate >
    <OtaCrashLogsList />
  </PagePrivate> 

